var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 10,
    fill: "#00DA0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3076 7.05762C14.5517 6.81354 14.9483 6.81355 15.1924 7.05762C15.4365 7.30169 15.4365 7.69831 15.1924 7.94238L9.69238 13.4424C9.44831 13.6865 9.05169 13.6865 8.80762 13.4424L6.55762 11.1924C6.31355 10.9483 6.31355 10.5517 6.55762 10.3076C6.80169 10.0635 7.19831 10.0635 7.44238 10.3076L9.25 12.1152L14.3076 7.05762Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkGreen);
export default __webpack_public_path__ + "static/media/check-mark-green.68da8a66f498147cb835e585d536625e.svg";
export { ForwardRef as ReactComponent };